import React from "react";
import { Link } from "react-router-dom";
import "./ForgetPassword.css";

const ForgetPassword = () => {
  return (
    <>
      <div className="signup">
        <div className="container h-100 text-white d-flex align-items-center justify-content-center">
          <div className="text-center w30">
            <div className="d-flex justify-content-center mb-5">
              <Link to='/'>
                <img className="cursor" src={require("../../../Asset/main logo.png")} alt="" />
              </Link>
            </div>
            <div className="guideline mb-5">
              <h4>Recover your password</h4>
              <p>Don’t Worry, Happens to the best of us.</p>
            </div>
            <form>
              <label className="form-label">Enter your email to recover youe account.</label>
              <input className="form-control form-control-lg mb-3" type="email" placeholder="Email" />
              <button type="submit" className="w-100 signup-btn mb-3 text-white">Email me a recovery link</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
